import { render, staticRenderFns } from "./TableSettingsModalSave.vue?vue&type=template&id=226f4fec"
import script from "./TableSettingsModalSave.vue?vue&type=script&lang=js"
export * from "./TableSettingsModalSave.vue?vue&type=script&lang=js"
import style0 from "./TableSettingsModalSave.vue?vue&type=style&index=0&id=226f4fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports